import { localStorage } from "@utils";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";

const chStatus = {
  requested: "请求中",
  rejected: "已拒绝",
  accepted: "已接受",
};

const enStatus = {
  requested: "Request",
  rejected: "Reject",
  accepted: "Accept",
};

const myStatus = {
  requested: "တောင်းဆိုထားသည်",
  rejected: "ငြင်းပယ်သည်",
  accepted: "လက်ခံသည်",
};

export const getStatus = (key) => {
  const userPreferedLanguage = localStorage.getUserPreferedLanguage();

  if (userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK) {
    return enStatus[key] ? enStatus[key] : key;
  } else if (userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK) {
    return myStatus[key] ? myStatus[key] : key;
  } else {
    return chStatus[key] ? chStatus[key] : key;
  }
};
